'use strict';

import 'angular';

import {findInput} from '../../utils';


export default function() {
	return {
		controller: controller,
	};

	function controller($log, $animate, $interpolate) {
		'ngInject';

		var group = this;

		group.currentSlide = null;
		group.history = [];
		group.slides = {};

		group.select = function(slideName, hideFromHistory) {
			if (slideName == group.currentSlide) {
				$log.debug(`Already on slide "${slideName}"`);
				return;
			}
			if (!group.slides.hasOwnProperty(slideName)) {
				throw `Slide with name "${slideName}" does not exist`;
			}
			group.slides[slideName].addClass('active');
			if (group.currentSlide) {
				group.slides[group.currentSlide].removeClass('active');
			}
			if (!hideFromHistory && group.currentSlide != null) {
				group.history.push(group.currentSlide);
			}
			group.currentSlide = slideName;

			// Autofocus
			var slide = group.slides[slideName];
			if (slide.attr('autofocus') !== undefined) {
				var input = findInput(slide);
				input[0].focus();
			}
		}

		group.back = function() {
			if (group.history.length == 0) {
				throw 'Slide group history is empty';
			}
			var slideName = group.history.pop();
			group.select(slideName, true);
		}

		group.addSlide = function(slideName, slide, overwrite) {
			$log.debug(`Adding slide "${slideName}"`);
			if(!overwrite && group.slides.hasOwnProperty(slideName)) {
				throw `Slide with name "${slideName}" already exists in this group`;
			}
			group.slides[slideName] = slide;
		}

		group.removeSlide = function(slideName) {
			$log.debug(`Removing slide "${slideName}"`);
			delete group.slides[slideName];
		}
	}
}
